module.exports = __webpack_public_path__ + "static/media/higuchi-building-4.a7c20c08.jpg";